import React from 'react';
import { Box, Flex, Heading, Table, Button, Text } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

import { TableLoaderOverlay } from 'shared/components';

import { useManageAlerts } from './manage-alerts.provider';
import { AlertActionsMenu } from './alert-actions-menu';
import './manage-alerts.scss';

const ManageAlertsView = () => {
   const manageALerts = useManageAlerts();
   const navigate = useNavigate();

   React.useEffect(() => {
      manageALerts.loadAlerts();
   }, []);

   return (
      <Box className="candidate-alerts">
         <header className="header">
            <Flex align="center" gap="1">
               <img alt="alert" src="/Images/jobseekerSide/Manage-Alerts2.png" />
               <Heading as="h3" size="7" className="heading">
                  Сповіщення
               </Heading>
            </Flex>

            <Button
               radius="small"
               size="4"
               onClick={() => {
                  navigate('/alerts/add');
               }}
            >
               Додати сповіщення
            </Button>
         </header>
         <Box pb="4">
            <Table.Root className="manage-alerts-table" layout="fixed" variant="ghost">
               <Table.Header className="table-header" id="alertsTable">
                  <Table.Row className="table-header-row">
                     <Table.ColumnHeaderCell
                        className="table-header-cell"
                        width="100px"
                        justify="center"
                        px="5"
                        py="4"
                     >
                        №
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell
                        width="220px"
                        className="table-header-cell"
                        px="5"
                        py="4"
                     >
                        Категорія
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell className="table-header-cell" px="5" py="4">
                        Спеціалізація
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell className="table-header-cell" px="5" py="4">
                        Країна
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell className="table-header-cell" px="5" py="4">
                        Місто
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell
                        className="table-header-cell"
                        width="120px"
                        justify="center"
                        px="5"
                        py="4"
                     >
                        Дія
                     </Table.ColumnHeaderCell>
                  </Table.Row>
               </Table.Header>

               <Table.Body>
                  <TableLoaderOverlay
                     show={manageALerts.loadAlertsState.status === 'pending'}
                     colSpan={4}
                  />

                  {manageALerts.alerts.map((alert, idx) => {
                     return (
                        <Table.Row className="table-row" key={alert.id}>
                           <Table.Cell
                              className="table-cell"
                              justify="center"
                              align="justify"
                              px="6"
                              py="4"
                           >
                              {idx + manageALerts.coef}
                           </Table.Cell>

                           <Table.Cell
                              className="table-cell"
                              width="205px"
                              align="char"
                              justify="start"
                              px="5"
                              py="4"
                           >
                              {alert.category.label}
                           </Table.Cell>

                           <Table.Cell
                              className="table-cell"
                              align="justify"
                              justify="start"
                              px="5"
                              py="4"
                           >
                              {alert.sub_category[0]?.label}
                           </Table.Cell>

                           <Table.Cell
                              className="table-cell"
                              align="justify"
                              justify="start"
                              px="5"
                              py="4"
                           >
                              {alert.country.label}
                           </Table.Cell>

                           <Table.Cell
                              className="table-cell"
                              align="justify"
                              justify="start"
                              px="5"
                              py="4"
                           >
                              {alert.city[0]?.label}
                           </Table.Cell>

                           <Table.Cell
                              className="table-cell action-cell"
                              justify="center"
                              px="5"
                              py="4"
                              align="justify"
                           >
                              <AlertActionsMenu candidateAlert={alert} />
                           </Table.Cell>
                        </Table.Row>
                     );
                  })}
               </Table.Body>
            </Table.Root>
         </Box>

         <Flex className="pagination" align='center' justify="center" pt="4" direction="column" gap="2">
            <Flex>
               {manageALerts.rawAlerts.length > 0 && (
                  <Text color="gray">
                     Кількість записів {manageALerts.recordsCount} of{' '}
                     {manageALerts.rawAlerts.length}
                  </Text>
               )}
            </Flex>
            <Box>
               <Flex align="center" gap="4">
                  <Button
                     radius="small"
                     size="4"
                     disabled={!manageALerts.canPrev}
                     onClick={() => {
                        manageALerts.onPrev();
                     }}
                  >
                     Попередня
                  </Button>

                  <Button
                     radius="small"
                     size="4"
                     disabled={!manageALerts.canNext}
                     onClick={() => {
                        manageALerts.onNext();
                     }}
                  >
                     Наступна
                  </Button>
               </Flex>
            </Box>
         </Flex>
      </Box>
   );
};

export const ManageAlerts = observer(ManageAlertsView);
